import React from 'react';
import { Link } from 'react-router-dom';
import { NAV_ITEMS } from '../../data/nav';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <Link className="footer-brand" to="/" aria-label="TrueNooch — home">
        TrueNooch<span className="tm">&trade;</span>
      </Link>
      <p className="footer-tagline">Deep, savory umami — real food that makes everything it touches better.</p>
      <p>Nut-, soy- &amp; gluten-free · Vegan · Complete Protein</p>

      <nav className="footer-nav" aria-label="Site footer navigation">
        {NAV_ITEMS.map((item, i) => (
          <React.Fragment key={item.page}>
            {i > 0 && <span className="footer-nav-divider">·</span>}
            <Link to={item.path}>{item.label}</Link>
          </React.Fragment>
        ))}
      </nav>

      <p className="footer-meta">
        &copy; {new Date().getFullYear()} TrueNooch, LLC · Colorado · All rights reserved.
      </p>

    </footer>
  );
}
